<template>
  <div>
    <headerSection :mainMenu="mainMenu"></headerSection>

    <!-- Running Text Section -->
    <RunningText
      text="เว็บตรง ไม่ล็อคยูส ฝาก-ถอน โอนไว 5 วินาที ไม่มีขั้นต่ำ ไม่ติดเทิร์น ไม่จำกัดการถอน คืนยอดเสีย 5% เเนะนำเพื่อนรับเพิ่ม 3% แอดมินบริการ 24 ชั่วโมง"
      extraClasses="home-style"
    />

    <!-- Main Layout Container -->
    <div class="main-layout">
      <!-- Desktop Layout -->
      <div class="desktop-layout desktop-only">
        <!-- Left Sidebar -->
        <LeftSidebar
          :leftMenuItems="leftMenuItems"
          :hoveredIndex="hoveredLeftIndex"
          :user="user"
          @menu-enter="onLeftMenuEnter"
          @menu-leave="onLeftMenuLeave"
        />

        <!-- Main Content Area -->
        <div class="main-content">
          <!-- Game Cover Section -->
          <div class="x-cover x-index-event-container" style="padding-top: 0px;">
            <img :src="coverDesktop" class="-bg" alt="PHENIX789 cover">
            <img :src="coverMobile" class="-bg -mobile" alt="PHENIX789 cover mobile">
            <div class="container-fluid -bg">
              <div class="row -contents-wrapper">
                <div class="col-12 col-md-6 -left-content"></div>
                <div class="col-12 col-md-6 -right-content bg-mobile">
                  <div data-slickable="{&quot;fade&quot;:true,&quot;arrows&quot;:false,&quot;autoplay&quot;:true,&quot;infinite&quot;:true,&quot;pauseOnHover&quot;:false,&quot;adaptiveHeight&quot;:true,&quot;slidesToShow&quot;:1,&quot;autoplaySpeed&quot;:5000}" data-animatable="fadeInUp" data-delay="200" class="slick-initialized slick-slider animated fadeInUp">
                    <div class="slick-list draggable" style="height: 58px;">
                      <div class="slick-track" style="opacity: 1; width: 100%;top:5px;display: flex;justify-content: flex-end;float: right;">
                        <div class="slick-slide slick-current slick-active resize bg-mobile2" data-slick-index="0" aria-hidden="false" style="position: relative; right: 0; top: 0px; z-index: 999; opacity: 1;">
                          <h1 class="-title">จัดหนักจัดเต็มกับการจัดกิจกรรม <br> และสิทธิพิเศษสุดคุ้ม</h1>
                          <p class="-sub-title">กิจกรรมมากที่สุดในไทย มีให้นักเดิมพันได้ร่วมสนุกทุกวัน</p>
                          <div class="-btn-wrapper d-none animated fadeInUp" data-animatable="fadeInUp" data-delay="500">
                            <a href="javascript:void(0)" class="btn -register-btn order-0" data-toggle="modal" data-target="#registerModal" tabindex="0">
                              <span class="-btn-title">สมัครสมาชิก</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Menu Bar -->
          <MainMenuBar
            :mainMenuItems="mainMenuItems"
            :hoveredIndex="hoveredMainIndex"
            :user="user"
            @menu-enter="onMainMenuEnter"
            @menu-leave="onMainMenuLeave"
          />

          <!-- Game Content -->
          <div class="content-wrapper">
            <!-- Games List Section -->
            <section class="x-category-index -v2">
              <div class="class-for-mobile x-index-content-main-container pb-4 -anon">
                <div class="-slot-games-list-container animated fadeInUp" data-animatable="fadeInUp" data-delay="150">
                  <ul class="navbar-nav">
                    <li v-if="mainMenu==='provider' && slotbrands && slotbrands.length" v-for="(item,index) in slotbrands" :class="{'nav-item':true,'-first':(index === 0)?true:false}">
                      <div class="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable" data-status="-cannot-entry -untestable">
                        <div class="-inner-wrapper">
                          <router-link :to="'/provider/'+item.provider" class="-btn -btn-play">
                            <picture>
                              <source type="image/png" :data-srcset="item.image.vertical" :srcset="item.image.vertical">
                              <img class="-cover-img img-fluid lazyloaded" alt="provider image" :data-src="item.image.vertical" :src="item.image.vertical">
                            </picture>
                          </router-link>
                        </div>
                      </div>
                    </li>
                    <li v-if="mainMenu==='fish' && fishgames && fishgames.length" v-for="(item,index) in fishgames" :class="{'nav-item':true,'-first':(index === 0)?true:false}">
                      <div class="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable" data-status="-cannot-entry -untestable">
                        <div class="-inner-wrapper">
                          <router-link :to="'/fish/'+item.provider" class="-btn -btn-play">
                            <picture>
                              <source type="image/png" :data-srcset="item.image.vertical" :srcset="item.image.vertical">
                              <img class="-cover-img img-fluid lazyloaded" alt="fish game" :data-src="item.image.vertical" :src="item.image.vertical">
                            </picture>
                          </router-link>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- Games Display Container -->
                <div class="-games-list-outer-container">
                  <div v-if="mainMenu==='provider'" :class="{'x-menu-mobile-sidebar-wrapper':true,'d-none':true}" style="position: relative;">
                    <div data-menu-sticky="js-sticky-widget" class="js-sticky-widget" style="width: auto; height: auto; top: 22px; bottom: 0px;">
                      <ul class="nav -menu-list">
                        <li v-for="(item) in slotbrands" class="nav-item">
                          <a href="javascript:void(0)" @click="gotoProvider('provider',item.provider)" :class="{'nav-link js-side-pgsoft-btn':true,'-active':(provider && provider === item.provider)?true:false}">
                            <picture>
                              <source type="image/webp" :srcset="item.image.horizontal">
                              <source type="image/png" :srcset="item.image.horizontal">
                              <img alt="provider" class="img-fluid -img-btn" height="50" v-lazy="item.image.horizontal">
                            </picture>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <!-- Main Games Grid -->
                  <div class="-games-list-inner-container -games-list-with-sidebar">
                    <div class="x-index-games-list-container pb-4 -scrollbar -main-block">
                      <div class="-games-list-container animated fadeInUp" data-animatable="fadeInUp" data-delay="150">
                        <div class="-games-section-container">
                          <!-- Search Section -->
                          <div class="d-flex justify-content-center">
                            <form class="form-inline my-2 my-lg-0 align-items-center">
                              <div class="search-wrapper">
                                <i class="fas fa-search search-icon"></i>
                                <input v-model="search" @keyup="searchData" class="form-control search-input" type="search" placeholder="ค้นหาชื่อเกม" aria-label="Search">
                              </div>
                            </form>
                          </div>
                          
                          <!-- Games Title -->
                          <h2 class="-section-title text-center" v-text="title"></h2>
                          
                          <!-- Slot Providers Grid (when showProviders is true) -->
                          <ul class="-provider-list" v-if="showProviders && slotbrands && slotbrands.length">
                            <li class="-provider-item-wrapper" v-for="provider in slotbrands" :key="provider.key || provider.provider">
                              <div class="x-provider-item-macro js-provider-toggle -untestable -can-entry" data-status="-can-entry -untestable">
                                <div class="-provider-inner-wrapper">
                                  <a href="javascript:void(0)" @click="selectBand(provider.key || provider.provider)" class="-provider-btn -provider-btn-play">
                                    <picture>
                                      <source type="image/png" :data-srcset="(provider && provider.askmepage && provider.askmepage.default) || provider.image.horizontal || provider.image.vertical" :srcset="(provider && provider.askmepage && provider.askmepage.default) || provider.image.horizontal || provider.image.vertical">
                                      <img class="-provider-cover-img img-fluid lazyloaded" :alt="provider.providerName" :data-src="(provider && provider.askmepage && provider.askmepage.default) || provider.image.horizontal || provider.image.vertical" :src="(provider && provider.askmepage && provider.askmepage.default) || provider.image.horizontal || provider.image.vertical">
                                    </picture>
                                    <div class="-provider-btn-overlay">
                                      <span class="-provider-btn-text">{{ provider.providerName }}</span>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </li>
                          </ul>

                          <!-- Games Grid -->
                          <ul class="-games-list" v-if="!showProviders && games && games.length">
                            <li class="-game-item-wrapper" v-for="game in games" :key="game.id">
                              <div class="x-game-list-item-macro js-game-list-toggle -untestable -can-entry" data-status="-can-entry -untestable">
                                <div class="-inner-wrapper">
                                  <template v-if="isLoggedIn">
                                    <router-link :to="{ name: 'PlayGame', query: {id: game.id, provider: game.provider, gameCategory: game.gameCategory}}" target="_blank" class="-btn -btn-play">
                                      <picture>
                                        <source type="image/png" :data-srcset="game.image.vertical" :srcset="game.image.vertical">
                                        <img class="-cover-img img-fluid lazyloaded" :alt="game.gameName" :data-src="game.image.vertical" :src="game.image.vertical">
                                      </picture>
                                      <div class="-btn-overlay">
                                        <span class="-btn-text">เข้าเล่น</span>
                                      </div>
                                    </router-link>
                                  </template>
                                  <template v-else>
                                    <a href="#loginModal" class="-btn -btn-play" data-toggle="modal" data-target="#loginModal">
                                      <picture>
                                        <source type="image/png" :data-srcset="game.image.vertical" :srcset="game.image.vertical">
                                        <img class="-cover-img img-fluid lazyloaded" :alt="game.gameName" :data-src="game.image.vertical" :src="game.image.vertical">
                                      </picture>
                                      <div class="-btn-overlay">
                                        <span class="-btn-text">เข้าเล่น</span>
                                      </div>
                                    </a>
                                  </template>
                                </div>
                              </div>
                            </li>
                          </ul>
                          
                          <!-- No Games/Providers Message -->
                          <div v-if="!showProviders && (!games || !games.length)" class="text-center py-5">
                            <p>ไม่พบเกมในหมวดหมู่นี้</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <!-- Mobile Layout -->
      <div class="mobile-layout mobile-only">
        <!-- Mobile Game Cover Section -->
        <div class="x-cover x-index-event-container mobile-cover" style="padding-top: 63px;">
          <img :src="coverDesktop" class="-bg" alt="PHENIX789 cover">
          <img :src="coverMobile" class="-bg -mobile" alt="PHENIX789 cover mobile">
          <div class="container-fluid -bg">
            <div class="row -contents-wrapper">
              <div class="col-12 col-md-6 -left-content"></div>
              <div class="col-12 col-md-6 -right-content bg-mobile">
                <div data-slickable="{&quot;fade&quot;:true,&quot;arrows&quot;:false,&quot;autoplay&quot;:true,&quot;infinite&quot;:true,&quot;pauseOnHover&quot;:false,&quot;adaptiveHeight&quot;:true,&quot;slidesToShow&quot;:1,&quot;autoplaySpeed&quot;:5000}" data-animatable="fadeInUp" data-delay="200" class="slick-initialized slick-slider animated fadeInUp">
                  <div class="slick-list draggable" style="height: 58px;">
                    <div class="slick-track" style="opacity: 1; width: 100%;top:5px;display: flex;justify-content: flex-end;float: right;">
                      <div class="slick-slide slick-current slick-active resize bg-mobile2" data-slick-index="0" aria-hidden="false" style="position: relative; right: 0; top: 0px; z-index: 999; opacity: 1;">
                        <h1 class="-title">จัดหนักจัดเต็มกับการจัดกิจกรรม <br> และสิทธิพิเศษสุดคุ้ม</h1>
                        <p class="-sub-title">กิจกรรมมากที่สุดในไทย มีให้นักเดิมพันได้ร่วมสนุกทุกวัน</p>
                        <div class="-btn-wrapper d-none animated fadeInUp" data-animatable="fadeInUp" data-delay="500">
                          <a href="javascript:void(0)" class="btn -register-btn order-0" data-toggle="modal" data-target="#registerModal" tabindex="0">
                            <span class="-btn-title">สมัครสมาชิก</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Main Menu -->
        <MobileMainMenu :mainMenuItems="mainMenuItems" :user="user" />

        <!-- Mobile With Sidebar Layout -->
        <div class="mobile-with-sidebar">
          <!-- Mobile Left Sidebar -->
          <MobileLeftSidebar
            :leftMenuItems="leftMenuItems"
            :hoveredIndex="hoveredLeftIndex"
            :user="user"
            @menu-enter="onLeftMenuEnter"
            @menu-leave="onLeftMenuLeave"
          />

          <!-- Mobile Content Area -->
          <div class="mobile-content">
            <!-- Mobile Game Content -->
            <div class="mobile-content-wrapper">
              <!-- Same game content as desktop but in mobile layout -->
              <div class="x-category-index -v2">
                <!-- Mobile Games Grid -->
                <div class="class-for-mobile x-index-content-main-container pb-4 -anon">
                  <div class="-games-list-outer-container">
                    <div class="-games-list-inner-container">
                      <div class="x-index-games-list-container pb-4 -scrollbar -main-block">
                        <div class="-games-list-container animated fadeInUp" data-animatable="fadeInUp" data-delay="150">
                          <div class="-games-section-container">
                            <!-- Mobile Search Section -->
                            <div class="d-flex justify-content-center mb-3">
                              <form class="form-inline my-2 my-lg-0 align-items-center">
                                <div class="search-wrapper">
                                  <i class="fas fa-search search-icon"></i>
                                  <input v-model="search" @keyup="searchData" class="form-control search-input" type="search" placeholder="ค้นหาชื่อเกม" aria-label="Search">
                                </div>
                              </form>
                            </div>
                            
                            <!-- Mobile Games Title -->
                            <h2 class="-section-title text-center" v-text="title"></h2>
                            
                            <!-- Mobile Slot Providers Grid (when showProviders is true) -->
                            <ul class="-provider-list" v-if="showProviders && slotbrands && slotbrands.length">
                              <li class="-provider-item-wrapper" v-for="provider in slotbrands" :key="provider.key || provider.provider">
                                <div class="x-provider-item-macro js-provider-toggle -untestable -can-entry" data-status="-can-entry -untestable">
                                  <div class="-provider-inner-wrapper">
                                    <a href="javascript:void(0)" @click="selectBand(provider.key || provider.provider)" class="-provider-btn -provider-btn-play">
                                      <picture>
                                        <source type="image/png" :data-srcset="(provider && provider.askmepage && provider.askmepage.default) || provider.image.horizontal || provider.image.vertical" :srcset="(provider && provider.askmepage && provider.askmepage.default) || provider.image.horizontal || provider.image.vertical">
                                        <img class="-provider-cover-img img-fluid lazyloaded" :alt="provider.providerName" :data-src="(provider && provider.askmepage && provider.askmepage.default) || provider.image.horizontal || provider.image.vertical" :src="(provider && provider.askmepage && provider.askmepage.default) || provider.image.horizontal || provider.image.vertical">
                                      </picture>
                                      <div class="-provider-btn-overlay">
                                        <span class="-provider-btn-text">{{ provider.providerName }}</span>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              </li>
                            </ul>

                            <!-- Mobile Games Grid -->
                            <ul class="-games-list" v-if="!showProviders && games && games.length">
                              <li class="-game-item-wrapper" v-for="game in games" :key="game.id">
                                <div class="x-game-list-item-macro js-game-list-toggle -untestable -can-entry" data-status="-can-entry -untestable">
                                  <div class="-inner-wrapper">
                                    <template v-if="isLoggedIn">
                                      <router-link :to="{ name: 'PlayGame', query: {id: game.id, provider: game.provider, gameCategory: game.gameCategory}}" target="_blank" class="-btn -btn-play">
                                        <picture>
                                          <source type="image/png" :data-srcset="game.image.vertical" :srcset="game.image.vertical">
                                          <img class="-cover-img img-fluid lazyloaded" :alt="game.gameName" :data-src="game.image.vertical" :src="game.image.vertical">
                                        </picture>
                                        <div class="-btn-overlay">
                                          <span class="-btn-text">เข้าเล่น</span>
                                        </div>
                                      </router-link>
                                    </template>
                                    <template v-else>
                                      <a href="#loginModal" class="-btn -btn-play" data-toggle="modal" data-target="#loginModal">
                                        <picture>
                                          <source type="image/png" :data-srcset="game.image.vertical" :srcset="game.image.vertical">
                                          <img class="-cover-img img-fluid lazyloaded" :alt="game.gameName" :data-src="game.image.vertical" :src="game.image.vertical">
                                        </picture>
                                        <div class="-btn-overlay">
                                          <span class="-btn-text">เข้าเล่น</span>
                                        </div>
                                      </a>
                                    </template>
                                  </div>
                                </div>
                              </li>
                            </ul>
                            
                            <!-- Mobile No Games/Providers Message -->
                            <div v-if="!showProviders && (!games || !games.length)" class="text-center py-5">
                              <p>ไม่พบเกมในหมวดหมู่นี้</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import router from './../router'
import firebase from 'firebase/app'
import _ from 'lodash'

export default {
  name: 'Main',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    LeftSidebar: () => import('@/components/LeftSidebar.vue'),
    MobileLeftSidebar: () => import('@/components/MobileLeftSidebar.vue'),
    MainMenuBar: () => import('@/components/MainMenuBar.vue'),
    MobileMainMenu: () => import('@/components/MobileMainMenu.vue'),
    RunningText: () => import('@/components/RunningText.vue')
  },
  mounted () {
    this.scrollToElement()
    this.syncRouteState()
  },
  watch: {
    newgames (newData) {
      if (newData) {
        this.syncRouteState()
      }
    },
    '$route.fullPath' () {
      this.syncRouteState()
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    isLoggedIn () {
      return this.user && (Array.isArray(this.user) ? this.user.length > 0 && this.user[0].key : this.user.key)
    },
    cardgames () {
      return this.$store.state.user.cardGames
    },
    slotbrands () {
      return this.$store.state.user.slotbrands
    },
    hotgames () {
      return this.$store.state.user.hotGames
    },
    newgames () {
      return this.$store.state.user.newGames
    },
    casinos () {
      return this.$store.state.user.casinoGames
    },
    fishgames () {
      return this.$store.state.user.fishgames
    },
    favoritegames () {
      return this.$store.state.user.favoritegames
    },
    swiper () {
      return this.$refs.mySwiper && this.$refs.mySwiper.$swiper
    },
    lastbonus () {
      return this.$store.state.user.lastbonus
    },
    allgames () {
      return this.$store.state.user.allgames
    },
    tredinggames () {
      return this.$store.state.user.tredinggames
    },
    coverDesktop () {
      const map = {
        favorite: require('@/assets/images/cover-favorite-bg.jpg'),
        popular: require('@/assets/images/cover-popular-bg.jpg'),
        casino: require('@/assets/images/cover-casino-bg.jpg'),
        slot: require('@/assets/images/cover-slot-bg.jpg'),
        fishing: require('@/assets/images/cover-fishing-bg.jpg'),
        grading: require('@/assets/images/cover-grading-bg.jpg')
      }
      const key = (this.mainMenu || 'slot').toString().toLowerCase()
      return map[key] || map['slot']
    },
    coverMobile () {
      const map = {
        favorite: require('@/assets/images/cover-favorite-bg-mobile.jpg'),
        popular: require('@/assets/images/cover-popular-bg-mobile.jpg'),
        casino: require('@/assets/images/cover-casino-bg-mobile.jpg'),
        slot: require('@/assets/images/cover-slot-bg-mobile.jpg'),
        fishing: require('@/assets/images/cover-fishing-bg-mobile.jpg'),
        grading: require('@/assets/images/cover-grading-bg-mobile.jpg')
      }
      const key = (this.mainMenu || 'slot').toString().toLowerCase()
      return map[key] || map['slot']
    }
  },
  data () {
    return {
      page: 1,
      games: [],
      provider: '',
      title: '',
      mainMenu: 'slot',
      selectedBand: '',
      showProviders: false,
      receiveAnounceMent: false,
      anoucement: {},
      balance: 0,
      fa_spin: false,
      search: '',
      busy: false,
      gamesOrder: [],
      hoveredLeftIndex: null,
      hoveredMainIndex: null,
      leftMenuItems: [
        { name: 'เล่นบ่อย', path: '/main?type=favorite', icon: require('@/assets/images/menu_left/left_1.png'), hoverIcon: require('@/assets/images/menu_left/left_1_hover.png') },
        { name: 'ยอดนิยม', path: '/main?type=popular', icon: require('@/assets/images/menu_left/left_2.png'), hoverIcon: require('@/assets/images/menu_left/left_2_hover.png') },
        { name: 'คาสิโน', path: '/main?type=casino', icon: require('@/assets/images/menu_left/left_3.png'), hoverIcon: require('@/assets/images/menu_left/left_3_hover.png') },
        { name: 'สล็อต', path: '/main?type=slot', icon: require('@/assets/images/menu_left/left_4.png'), hoverIcon: require('@/assets/images/menu_left/left_4_hover.png') },
        { name: 'ยิงปลา', path: '/main?type=fishing', icon: require('@/assets/images/menu_left/left_5.png'), hoverIcon: require('@/assets/images/menu_left/left_5_hover.png') },
        { name: 'กีฬา', path: '/playsport', icon: require('@/assets/images/menu_left/left_6.png'), hoverIcon: require('@/assets/images/menu_left/left_6_hover.png') },
        { name: 'esport', path: '/playesport', icon: require('@/assets/images/menu_left/left_7.png'), hoverIcon: require('@/assets/images/menu_left/left_7_hover.png') },
        { name: 'hilo', path: '/playlotto', icon: require('@/assets/images/menu_left/left_9.png'), hoverIcon: require('@/assets/images/menu_left/left_9_hover.png') }
      ],
      mainMenuItems: [
        { name: 'โปรโมชั่น', path: '/promotion', icon: require('@/assets/images/menu_main/main_menu_1.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_1.png') },
        { name: 'แลกของรางวัล', path: '/rewards', icon: require('@/assets/images/menu_main/main_menu_2.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_2.png') },
        { name: 'คืนยอดเล่น', path: '/cashback', icon: require('@/assets/images/menu_main/main_menu_3.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_3.png') },
        { name: 'สิทธิพิเศษ', path: '/event', icon: require('@/assets/images/menu_main/main_menu_4.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_4.png') },
        { name: 'พันธมิตร', path: '/partner', icon: require('@/assets/images/menu_main/main_menu_5.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_5.png') },
        // { name: 'ฝากต่อเนื่อง', path: '/continue', icon: require('@/assets/images/menu_main/main_menu_6.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_6.png') }
      ]
    }
  },
  methods: {
    normalizeProvider (provider) {
      return (provider || '').toString().trim().toLowerCase()
    },
    getRouteProvider () {
      return this.$route.params.provider || this.$route.query.provider || ''
    },
    hasProvider (providers, provider) {
      const normalizedProvider = this.normalizeProvider(provider)
      return !!normalizedProvider && providers.some(item => this.normalizeProvider(item.provider) === normalizedProvider)
    },
    resolveMainMenu () {
      const queryType = this.$route.query.type
      if (queryType) {
        return queryType
      }

      const routeName = this.$route.name
      if (routeName && routeName !== 'main') {
        if (routeName === 'providerName' || routeName === 'provider') return 'provider'
        if (routeName === 'casinoName') return 'casino'
        if (routeName === 'fishName') return 'fish'
        return routeName
      }

      const provider = this.getRouteProvider()
      if (provider) {
        if (this.hasProvider(this.casinos, provider)) return 'casino'
        if (this.hasProvider(this.fishgames, provider)) return 'fish'
        if (this.hasProvider(this.slotbrands, provider)) return 'slot'
      }

      return 'slot'
    },
    syncRouteState () {
      this.mainMenu = this.resolveMainMenu()
      this.provider = this.getRouteProvider()
      this.selectedBand = this.$route.query.band || ((this.mainMenu === 'slot' || this.mainMenu === 'provider') ? this.provider : '')
      this.renderTitleTotalGame()
    },
    // Menu hover methods
    onLeftMenuEnter (index) {
      this.hoveredLeftIndex = index
    },
    onLeftMenuLeave () {
      this.hoveredLeftIndex = null
    },
    onMainMenuEnter (index) {
      this.hoveredMainIndex = index
    },
    onMainMenuLeave () {
      this.hoveredMainIndex = null
    },
    scrollToElement() {
      window.onscroll = () => {
        const body = document.body; const html = document.documentElement;
        const height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight )
        const bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight + document.documentElement.offsetHeight)+500 > height;
        if (bottomOfWindow) {
         this.page++
         this.renderTitleTotalGame()
        }
      }
    },
    searchData () {
      if (this.search && this.allgames) {
        const search = this.search
        const results = _.filter(this.allgames, (obj) => {
          return obj.gameName.toLowerCase().indexOf(search.toString().toLowerCase()) !== -1
        })
        const check = []
        const games = []
        for (const x in results) {
          if (!check[results[x].id]) {
            games.push(results[x])
            check[results[x].id] = true
          }
        }
        this.games = _.orderBy(games, ['gameName'], ['asc'])
      }else{
        this.renderTitleTotalGame()
      }
    },
    showGame (type) {
      if (type === 'fish') {
        this.title = 'เกมส์ยิงปลาทั้งหมด'
        const games = []
        const check = []
        for (const x in this.fishgames) {
          for (const xx in this.fishgames[x].games) {
            if (!check[this.fishgames[x].games[xx].id]) {
              games.push(this.fishgames[x].games[xx])
              check[this.fishgames[x].games[xx].id] = true
            }
          }
        }
        this.games = _.orderBy(games, ['gameName'], ['asc'])
      } else {
        this.title = 'เกมส์สล๊อตทั้งหมด'
        const games = []
        const check = []
        for (const x in this.slotbrands) {
          for (const xx in this.slotbrands[x].games) {
            if (!check[this.slotbrands[x].games[xx].id]) {
              games.push(this.slotbrands[x].games[xx])
              check[this.slotbrands[x].games[xx].id] = true
            }
          }
        }
        this.games = _.orderBy(games, ['gameName'], ['asc'])
      }
    },
    renderTitleTotalGame () {
      if (this.search) return

      const routeProvider = this.getRouteProvider()
      const normalizedRouteProvider = this.normalizeProvider(routeProvider)
      
      // Handle different game types based on query parameter
      if (this.mainMenu === 'favorite') {
        this.title = 'เกมส์โปรด'
        this.games = _.orderBy(this.favoritegames, ['gameName'], ['asc'])
      } else if (this.mainMenu === 'popular' || this.mainMenu === 'hotgames') {
        this.title = 'เกมส์ยอดนิยม'
        this.games = _.orderBy(this.hotgames, ['gameName'], ['asc'])
      } else if (this.mainMenu === 'newgames') {
        this.title = 'เกมส์ใหม่'
        this.games = _.orderBy(this.newgames, ['gameName'], ['asc'])
      } else if (this.mainMenu === 'casino') {
        if (routeProvider) {
          this.provider = routeProvider
        } else {
          this.title = 'คาสิโนทั้งหมด'
        }
        const games = []
        const check = []
        for (const x in this.casinos) {
          if (normalizedRouteProvider && this.normalizeProvider(this.casinos[x].provider) === normalizedRouteProvider) {
            this.title = 'ค่าย ' + this.casinos[x].providerName
            this.games = _.orderBy(this.casinos[x].games, ['gameName'], ['asc'])
            break
          } else {
            for (const xx in this.casinos[x].games) {
              if (!check[this.casinos[x].games[xx].id]) {
                games.push(this.casinos[x].games[xx])
                check[this.casinos[x].games[xx].id] = true
              }
            }
          }
        }
        if (!routeProvider) {
          this.games = _.orderBy(games, ['gameName'], ['asc'])
        }
      } else if (this.mainMenu === 'sport') {
        this.title = 'สปอร์ต'
        this.games = []
      } else if (this.mainMenu === 'fishing' || this.mainMenu === 'fish') {
        if (routeProvider) {
          this.provider = routeProvider
        } else {
          this.title = 'เกมส์ยิงปลาทั้งหมด'
        }
        const games = []
        const check = []
        for (const x in this.fishgames) {
          if (normalizedRouteProvider && this.normalizeProvider(this.fishgames[x].provider) === normalizedRouteProvider) {
            this.title = 'เกมส์ยิงปลาค่าย ' + this.fishgames[x].providerName
            this.games = _.orderBy(this.fishgames[x].games, ['gameName'], ['asc'])
            break
          } else {
            for (const xx in this.fishgames[x].games) {
              if (!check[this.fishgames[x].games[xx].id]) {
                games.push(this.fishgames[x].games[xx])
                check[this.fishgames[x].games[xx].id] = true
              }
            }
          }
        }
        if (!routeProvider) {
          this.games = _.orderBy(games, ['gameName'], ['asc'])
        }
      } else if (this.mainMenu === 'lotto') {
        this.title = 'หวย'
        this.games = []
      } else if (this.mainMenu === 'grading') {
        this.title = 'เกรดดิ้ง'
        this.games = _.orderBy(this.tredinggames, ['gameName'], ['asc'])
      } else if (this.mainMenu === 'provider' || this.mainMenu === 'slot') {
        const selectedProviderKey = this.selectedBand || this.$route.query.band || routeProvider

        if (selectedProviderKey) {
          // Find the specific provider in slotbrands
          for (const x in this.slotbrands) {
            if (this.slotbrands[x].key === selectedProviderKey || this.normalizeProvider(this.slotbrands[x].provider) === this.normalizeProvider(selectedProviderKey)) {
              this.title = 'เกมส์สล๊อตค่าย ' + this.slotbrands[x].providerName
              this.games = _.orderBy(this.slotbrands[x].games, ['gameName'], ['asc'])
              this.showProviders = false
              return
            }
          }
        }
        
        // If no band parameter, show provider selection (brand images)
        if (this.mainMenu === 'slot' && !selectedProviderKey) {
          this.title = 'เลือกค่ายเกมส์สล๊อต'
          this.games = []
          this.showProviders = true
          return
        }

        // Legacy provider handling (existing functionality)
        this.title = 'เกมส์สล๊อตค่าย'
        if (routeProvider) {
          this.provider = routeProvider
        } else {
          this.title = 'เกมส์สล๊อตทั้งหมด'
        }
        const games = []
        const check = []
        const perpage = 100
        for (const x in this.slotbrands) {
          if (normalizedRouteProvider && this.normalizeProvider(this.slotbrands[x].provider) === normalizedRouteProvider) {
            this.title = 'เกมส์สล๊อตค่าย ' + this.slotbrands[x].providerName
            this.games = _.orderBy(this.slotbrands[x].games, ['gameName'], ['asc'])
            break
          } else {
            for (const xx in this.slotbrands[x].games) {
              if (!check[this.slotbrands[x].games[xx].id]) {
                games.push(this.slotbrands[x].games[xx])
                check[this.slotbrands[x].games[xx].id] = true
              }
            }
          }
        }
        if (!routeProvider) {
          const gamesOrder = _.orderBy(games, ['gameName'], ['asc'])
          this.games = gamesOrder.splice(0, (this.page * perpage))
          this.gamesOrder = gamesOrder
        }
        this.showProviders = false
      }
    },
    gotoProvider (type, provider) {
      this.$router.push('/' + type + '/' + provider)
    },
    selectBand (providerKey) {
      this.$router.push({
        path: '/main',
        query: { 
          type: 'slot',
          band: providerKey
        }
      })
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/')
      }
    }
  }
}
</script>

<style scoped>
/* Desktop Layout */
.desktop-layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  margin-left: 100px;
  padding-top: 105px;
  width: calc(100% - 100px);
  min-height: 100vh;
  background-image: url('../assets/images/background/desktop.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Ensure x-cover appears above menu */
.main-content .x-cover {
  position: relative;
}

/* Desktop cover styles */
.desktop-layout .x-cover .-bg {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
}

.desktop-layout .x-cover .-bg.-mobile {
  display: none;
}

.content-wrapper {
  padding: 20px;
}

/* Mobile Layout */
.mobile-layout {
  display: none;
  padding-top: 105px;
  min-height: 100vh;
  background-image: url('../assets/images/background/mobile.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Mobile cover section positioning */
.mobile-layout .mobile-cover {
  margin-top: -105px;
  padding-top: 105px;
}

.mobile-with-sidebar {
  display: flex;
  min-height: calc(100vh - 300px);
}

.mobile-content-wrapper {
  padding: 10px;
}

/* Mobile x-cover positioning */
.mobile-cover {
  position: relative;
  width: 100%;
  height: auto;
  max-height: 200px;
  overflow: hidden;
}

.mobile-cover .-bg {
  width: 100%;
  height: auto;
  object-fit: cover;
  max-height: 200px;
}

.mobile-cover .container-fluid {
  padding: 10px;
}

.mobile-cover .-title {
  font-size: 18px !important;
  line-height: 1.3;
  margin-bottom: 5px;
}

.mobile-cover .-sub-title {
  font-size: 14px !important;
  line-height: 1.2;
}

/* Responsive Utilities */
.desktop-only {
  display: block;
}

.mobile-only {
  display: none;
}

@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: block;
  }

  .desktop-layout {
    display: none;
  }

  /* Show mobile cover image on smaller screens */
  .desktop-layout .x-cover .-bg:not(.-mobile) {
    display: none;
  }
  
  .desktop-layout .x-cover .-bg.-mobile {
    display: block;
  }

  .mobile-layout {
    display: block;
  }
}

/* Container fixes for desktop */
.-games-list-outer-container {
  width: 100%;
  padding: 0 20px;
}

.-games-list-inner-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.x-index-games-list-container {
  width: 100%;
}

.-games-list-container {
  width: 100%;
}

.-games-section-container {
  width: 100%;
  padding: 20px 0;
}

/* Game Grid Styles */
.-games-list {
  list-style: none !important;
  padding: 0 !important;
  display: flex !important;
  flex-wrap: wrap !important;
  flex-direction: row !important;
  justify-content: flex-start;
  margin: 0 -6px;
}

.-game-item-wrapper {
  padding: 0 6px;
  margin-bottom: 15px;
}

/* Responsive grid columns - More items per row */
@media (min-width: 1400px) {
  .-game-item-wrapper {
    flex: 0 0 12.5% !important;
    max-width: 12.5% !important;
  }
}

@media (min-width: 1200px) and (max-width: 1399px) {
  .-game-item-wrapper {
    flex: 0 0 14.285% !important;
    max-width: 14.285% !important;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .-game-item-wrapper {
    flex: 0 0 16.666% !important;
    max-width: 16.666% !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .-game-item-wrapper {
    flex: 0 0 20% !important;
    max-width: 20% !important;
  }
}

.x-game-list-item-macro {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
}

.x-game-list-item-macro:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
}

.-inner-wrapper {
  position: relative;
}

.-btn-play {
  display: block;
  text-decoration: none;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 3/4;
}

.-cover-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.x-game-list-item-macro:hover .-cover-img {
  transform: scale(1.05);
}

.-btn-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(223, 72, 24, 0.8), rgba(0, 0, 0, 0.8));
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
  border-radius: 12px;
}

.x-game-list-item-macro:hover .-btn-overlay {
  opacity: 1;
}

.-btn-text {
  color: white;
  font-weight: bold;
  font-size: 16px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  backdrop-filter: blur(10px);
}

.-section-title {
  color: #fff;
  margin: 30px 0;
  font-weight: bold;
  font-size: 28px;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

/* Search Form Enhancement */
.d-flex.justify-content-center {
  margin-bottom: 30px;
}

.form-control {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  padding: 12px 20px;
  border-radius: 25px;
  font-size: 16px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.form-control::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.form-control:focus {
  background: rgba(255, 255, 255, 0.2);
  border-color: #DF4818;
  color: #fff;
  box-shadow: 0 0 15px rgba(223, 72, 24, 0.3);
  outline: none;
}

/* Search Input Wrapper */
.search-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 300px;
}

.search-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(223, 72, 24, 0.7);
  font-size: 16px;
  pointer-events: none;
  z-index: 2;
}

/* Enhanced Search Input */
.search-input {
  max-width: 300px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.05));
  border: 2px solid rgba(223, 72, 24, 0.3);
  padding: 14px 25px 14px 45px;
  border-radius: 30px;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
  width: 100%;
}

.search-input:hover {
  border-color: rgba(223, 72, 24, 0.5);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));
  transform: translateY(-1px);
}

.search-input:focus {
  border-color: #DF4818;
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 0 20px rgba(223, 72, 24, 0.4), inset 0 0 10px rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

/* Slot Provider Grid Styles (Horizontal Layout) */
.-provider-list {
  list-style: none !important;
  padding: 0 !important;
  display: flex !important;
  flex-wrap: wrap !important;
  flex-direction: row !important;
  justify-content: flex-start;
  margin: 0 -10px;
  gap: 20px;
  justify-content: center;
}

.-provider-item-wrapper {
  padding: 0 10px;
  margin-bottom: 20px;
  flex: 0 0 auto;
  width: auto;
}

.x-provider-item-macro {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  width: 300px;
  height: auto;
}

.x-provider-item-macro:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
}

.-provider-inner-wrapper {
  position: relative;
  width: 300px;
  height: auto;
}

.-provider-btn-play {
  display: block;
  text-decoration: none;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  width: 300px;
  height: auto;
}

.-provider-cover-img {
  width: 300px;
  height: auto;
  display: block;
  object-fit: contain;
  background: rgba(255, 255, 255, 0.1);
  transition: transform 0.3s ease;
}

.x-provider-item-macro:hover .-provider-cover-img {
  transform: scale(1.05);
}

.-provider-btn-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(223, 72, 24, 0.8), rgba(0, 0, 0, 0.8));
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
  border-radius: 12px;
}

.x-provider-item-macro:hover .-provider-btn-overlay {
  opacity: 1;
}

.-provider-btn-text {
  color: white;
  font-weight: bold;
  font-size: 16px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  text-align: center;
}

/* Responsive breakpoints for provider grid */

/* Mobile specific adjustments */
@media (max-width: 768px) {
  .-games-list-outer-container {
    padding: 0 10px;
  }
  
  .-game-item-wrapper {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 0 5px;
  }
  
  /* Mobile provider adjustments */
  .-provider-list {
    gap: 0;
  }
  
  .-provider-item-wrapper {
    flex: 0 0 auto;
    width: auto;
    margin-bottom: 15px;
  }
  
  .x-provider-item-macro {
    width: 120px;
    height: auto;
  }
  
  .-provider-cover-img {
    width: 120px;
    height: auto;
  }
  
  .-provider-btn-play {
    width: 120px;
    height: auto;
  }
  
  .-provider-inner-wrapper {
    width: 120px;
    height: auto;
  }
  
  .-provider-btn-text {
    font-size: 14px;
    padding: 6px 12px;
  }
  
  .mobile-main-menu-item {
    min-width: 40px;
    padding: 6px;
  }
  
  .mobile-cover {
    max-height: 150px;
  }
  
  .mobile-cover .-title {
    font-size: 16px !important;
  }
  
  .mobile-cover .-sub-title {
    font-size: 12px !important;
  }
  
  .-section-title {
    font-size: 24px;
    margin: 20px 0;
  }
  
  .form-control {
    max-width: 280px;
    margin: 0 auto;
  }
  
  /* Mobile Search Input Adjustments */
  .search-wrapper {
    max-width: 100%;
    width: calc(100% - 20px);
  }
  
  .search-input {
    max-width: 100%;
    width: 100%;
    font-size: 14px;
    padding: 12px 20px 12px 40px;
    border-radius: 25px;
  }
  
  .search-icon {
    font-size: 14px;
    left: 15px;
  }
  
  /* Mobile adjustments for class-for-mobile */
  .class-for-mobile .-game-item-wrapper {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 0 5px;
  }
  
}

/* Desktop styles for class-for-mobile (favorite page) */
@media (min-width: 768px) {
  .class-for-mobile .-games-list {
    justify-content: flex-start;
  }

  .class-for-mobile .-game-item-wrapper {
    flex: 0 0 16.66%;
    max-width: 240px;
    min-width: 160px;
    padding: 0 6px;
    margin-bottom: 15px;
  }

  .class-for-mobile .x-game-list-item-macro {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.3s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
  }

  .class-for-mobile .x-game-list-item-macro:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
  }

  .class-for-mobile .-btn-play {
    aspect-ratio: 3/4;
    width: 100%;
    height: auto;
  }

  .class-for-mobile .-cover-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
}

/* Background styles for mobile */
.bg-mobile2 {
  margin-right: 100px;
}

@media screen and (max-width: 992px) {
  .resize {
    width: 899px;
  }
}

@media screen and (max-width: 600px) {
  .resize {
        width: 399px;
    }

    .mobile-cover {
        max-height: 350px;
    }

    .mobile-cover .-bg {
        max-height: 250px;
    }

    .mobile-cover .-title {
        font-size: 16px !important;
    }

    .mobile-cover .-sub-title {
        font-size: 12px !important;
    }
}

.mobile-cover .-bg.-mobile {
  display: block;
}
</style>
